module.exports = __webpack_public_path__ + "static/media/money.f26c12f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/money.svg
// module id = 139
// module chunks = 0